import { render, staticRenderFns } from "./LoanAmountRelease.vue?vue&type=template&id=0f5bec1c&"
import script from "./LoanAmountRelease.vue?vue&type=script&lang=js&"
export * from "./LoanAmountRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports